import type { PropsWithChildren } from 'react';
import * as Headless from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

import { cls } from '@/utils/cls';

export type DisclosureProps = {
  className?: string;
};

export function Disclosure({
  children,
  className,
}: PropsWithChildren<DisclosureProps>) {
  return (
    <div className={className}>
      <Headless.Disclosure>{children}</Headless.Disclosure>
    </div>
  );
}

export type DisclosureTitleProps = {};

export function DisclosureTitle({
  children,
}: PropsWithChildren<DisclosureTitleProps>) {
  return (
    <Headless.Disclosure.Button
      className={cls(
        'flex w-full cursor-pointer justify-between border-b border-gray-900/10 py-3 ui-open:border-0',
      )}
    >
      <div className="text-lg font-medium text-gray-900">{children}</div>
      <div className="flex flex-col justify-center rounded-full hover:bg-gray-900/5">
        <ChevronDownIcon
          className={cls(
            'size-6 text-gray-900/80 transition-transform duration-300 ui-open:rotate-180',
          )}
        />
      </div>
    </Headless.Disclosure.Button>
  );
}

export type DisclosurePanelProps = { className?: string };

export function DisclosurePanel({
  children,
  className,
}: PropsWithChildren<DisclosurePanelProps>) {
  return (
    <Headless.Disclosure.Panel className={className}>
      {children}
    </Headless.Disclosure.Panel>
  );
}
